export default __webpack_public_path__ + "static/media/cross-sectoral-banner.8e0ea3d9.png";